/**
 * IP18 preorder Complete Your Setup — tab panels.
 */
(function () {
  'use strict';

  class Ip18PreorderComplete extends HTMLElement {
    connectedCallback() {
      if (this._onClick) {
        this.removeEventListener('click', this._onClick);
      }
      this._onClick = this._onClickHandler.bind(this);
      this.addEventListener('click', this._onClick);
      var current = this.querySelector('[data-complete-tab].is-active, [data-complete-tab][aria-selected="true"]')
        || this.querySelector('[data-complete-tab]');
      if (current) this._show(current.getAttribute('data-complete-tab'));
    }

    disconnectedCallback() {
      if (this._onClick) this.removeEventListener('click', this._onClick);
    }

    _onClickHandler(event) {
      var tab = event.target.closest('[data-complete-tab]');
      if (!tab || !this.contains(tab)) return;
      this._show(tab.getAttribute('data-complete-tab'));
    }

    _show(id) {
      var tabs = this.querySelectorAll('[data-complete-tab]');
      var panels = this.querySelectorAll('[data-complete-panel]');
      tabs.forEach(function (el) {
        var on = el.getAttribute('data-complete-tab') === id;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (el) {
        el.hidden = el.getAttribute('data-complete-panel') !== id;
      });
    }
  }

  if (!customElements.get('ip18-preorder-complete')) {
    customElements.define('ip18-preorder-complete', Ip18PreorderComplete);
  }
})();
